import routerOptions0 from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/usr/src/nuxt-app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}